/**
 * Utility for injecting structured mention tokens before submission.
 * This takes a map of { [username]: userId } and replaces all occurrences
 * of @username in the text with the structured token @[username](userId).
 */
export function injectStructuredMentions(text, mentionMap) {
  if (!text || typeof text !== "string") return text;
  if (!mentionMap || Object.keys(mentionMap).length === 0) return text;

  let finalString = text;

  const sortedEntries = Object.entries(mentionMap).sort((a, b) => b[0].length - a[0].length);

  sortedEntries.forEach(([username, userId]) => {
    if (!username || !userId) return;

    // Escape regex special characters in the username
    const escapedName = username.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
    
    // Match @username exactly (case-insensitive for safety)
    const regex = new RegExp(`@${escapedName}`, 'gi');
    
    finalString = finalString.replace(regex, `@[${username}](${userId})`);
  });

  return finalString;
}

/**
 * Parses text containing structured tokens @[username](userId)
 * and returns the stripped plain text (@username) along with
 * a map of { [username]: userId } to prime the editor's state.
 */
export function stripStructuredMentions(text) {
  if (!text || typeof text !== "string") {
    return { plainText: text || "", mentionMap: {} };
  }

  const mentionMap = {};
  
  // Replace all @[name](id) with @name and populate the map
  const plainText = text.replace(/@\[([^\]]+)\]\(([^)]+)\)/g, (match, username, userId) => {
    if (username && userId) {
      mentionMap[username] = userId;
      return `@${username}`;
    }
    return match; // Fallback if malformed
  });

  return { plainText, mentionMap };
}
